import actionTypes from '../../actions/actionTypes'

const defaultState = {
	colors: [],
}

function updateFoldersColors(state, action) {
	const newState = {...state}
	const defaultColor = {
		id: '0',
		color: {
			r: '184',
			g: '192',
			b: '198',
		},
	}
	newState.colors = [defaultColor, ...action.payload.entities]
	return newState
}

const foldersReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.FOLDERS_GET_COLORS_SUCCESS:
			return updateFoldersColors(state, action)
		default: return state
	}
}

export default foldersReducer
